import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getPage, getPages } from 'redux/actions/pagesActions';
import { createObject, getObjects } from 'redux/actions/objectsAction';
import { getQlikObjects, getQlikSheets } from 'redux/actions/qlikActions';
import { Grid, Divider, Typography, Button, Box } from '@material-ui/core';
import Header from 'components/layout/Partials/Header';

import TextFieldGroup from 'components/common/TextFieldGroup';
import SelectFieldGroup from 'components/common/SelectFieldGroup';
import TextAreaFieldGroup from 'components/common/TextAreaFieldGroup';
import * as lodash from 'lodash';
import AdminLayout from 'components/layout/AdminLayout';
import { Theme } from 'utils/Theme';
import { withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import Section from 'components/UI/Section';

const { isEmpty } = lodash;
const styles = Theme();

class CreateObject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            object: {
                title: '',
                qsId: '',
                qsSheetId: '',
                height: '',
                exportData: '',
                type: 'QdtViz',
                description: '',
                editorState: '',
                xs: 12,
                sm: 6,
                md: 4,
                elevation: 2,
            },
            errors: {},
            manual_entry: false,
            loadingQlikSheets: false,
            qsApp: null,
            sheet: '',
            sheets: null,
            objects: null,
        };

        this.onChange = this.onChange.bind(this);
        this.onSelectSheet = this.onSelectSheet.bind(this);
        // this.onGetSheetsClick = this.onGetSheetsClick(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        this.props.getPage(this.props.match.params.id);
    }

    onGetSheetsClick(qsApp) {
        this.props.getQlikSheets(qsApp);
        this.setState({ loadingQlikSheets: true });
    }

    UNSAFE_componentWillReceiveProps(nextProps, prevState) {
        //wait for both pages and server details to load
        if (nextProps.pages && nextProps.qsServer) {
            if (nextProps.pages.page) {
                const page = nextProps.pages.page;

                //check page has app
                const qsApp =
                    page.qsApp && !isEmpty(page.qsApp)
                        ? page.qsApp
                        : nextProps.qsServer.qsServer.app;

                this.setState({
                    parent: page.parent,
                    title: page.title,
                    status: page.status,
                    description: page.description,
                    type: 'qAppViz',
                    qsApp,
                    menu: page.menu,
                    template: page.template,
                });
            }
        }

        //CHECK FOR ERRORS
        if (nextProps.errors) {
            this.setState({ errors: nextProps.errors });
        }

        //When Sheets have been loaded from JSQlikLoader
        if (nextProps.qlik.sheets) {
            const sheets = nextProps.qlik.sheets.map((sheet) => {
                return { key: sheet.qInfo.qId, title: sheet.qMeta.title };
            });

            this.setState({ sheets });
        }

        //when objects have been loaded from sheet from qlik
        if (nextProps.qlik.objects) {
            let objects = [];
            nextProps.qlik.objects.forEach((object) => {
                const key = object.name;
                const title = `${object.type} ${object.name}`;
                objects.push({ key, title });
            });
            this.setState({ objects });
        }

        //check for authentication always
        if (nextProps.auth) {
            if (!nextProps.auth.isAuthenticated) {
                this.props.history.push('/login');
            }
        }
    }

    onChange(e) {
        const state = this.state;
        state.object[e.target.name] = e.target.value;
        this.setState(state);
    }

    onSelectSheet(e) {
        const sheetId = e.target.value;
        const { object, qsApp } = this.state;
        object.qsSheetId = sheetId;

        this.setState({ sheet: sheetId, object });
        this.props.getQlikObjects(qsApp, sheetId);
    }

    onSubmit(e) {
        e.preventDefault();
        let object = this.state.object;
        object.row = this.props.match.params.row;
        object.sortOrder = this.props.match.params.sortOrder;

        this.props.createObject(
            this.props.match.params.id,
            this.state.object,
            this.props.history
        );
    }

    handleSelect = (e) => {
        this.setState({
            object: { ...this.state.object, [e.target.name]: e.target.value },
        });
    };

    render() {
        const { errors, sheets, qsApp, objects } = this.state;
        const { pages, classes } = this.props;
        const page = pages.page;
        return (
            <AdminLayout>
                <div className="o-page">
                    <Header hideSearchBar title={'New Qlik Object'} />
                    <Box component="div" className={'u-p-xsmall'}>
                        <Section>
                            <div
                                className={clsx(
                                    'u-m-xsmall full_height u-p-small'
                                )}
                            >
                                <div className={'u-m-zero'}>
                                    <div className="o-line ">
                                        <div>
                                            <h4 className={`c-card__title `}>
                                                {page?.title} | Create Object
                                            </h4>
                                        </div>
                                        <div>
                                            <Button
                                                className={`${classes.buttonSecondary}`}
                                                onClick={(e) =>
                                                    this.props.history.goBack()
                                                }
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="row u-justify-center">
                                            <div className="col-sm-12 u-m-auto u-mb-medium">
                                                <div>
                                                    <div>
                                                        <form
                                                            noValidate
                                                            onSubmit={
                                                                this.onSubmit
                                                            }
                                                        >
                                                            <Grid
                                                                container
                                                                spacing={2}
                                                            >
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={3}
                                                                >
                                                                    {sheets !==
                                                                    null ? (
                                                                        <SelectFieldGroup
                                                                            label={
                                                                                'Qlik Sense Sheet'
                                                                            }
                                                                            onChange={
                                                                                this
                                                                                    .onSelectSheet
                                                                            }
                                                                            name={
                                                                                'sheet'
                                                                            }
                                                                            value={
                                                                                this
                                                                                    .state
                                                                                    .sheet ||
                                                                                ''
                                                                            }
                                                                            options={
                                                                                sheets
                                                                            }
                                                                            error={
                                                                                errors.sheets
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        <div className="c-field u-pt-xsmall ">
                                                                            <div className="u-pt-small ">
                                                                                <Button
                                                                                    color={
                                                                                        'primary'
                                                                                    }
                                                                                    type={
                                                                                        'button'
                                                                                    }
                                                                                    onClick={() =>
                                                                                        this.onGetSheetsClick(
                                                                                            qsApp
                                                                                        )
                                                                                    }
                                                                                    className={`c-btn ${classes.buttonPrimary} c-btn--fullwidth`}
                                                                                >
                                                                                    Load
                                                                                    Qlik
                                                                                    App
                                                                                    Sheets
                                                                                </Button>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={3}
                                                                >
                                                                    {objects ===
                                                                        null && (
                                                                        <TextFieldGroup
                                                                            label="Qlik Sense Object ID"
                                                                            type="text"
                                                                            disabled={
                                                                                true
                                                                            }
                                                                            onChange={
                                                                                this
                                                                                    .onChange
                                                                            }
                                                                            value={
                                                                                this
                                                                                    .state
                                                                                    .object
                                                                                    .qsId ||
                                                                                ''
                                                                            }
                                                                            name="qsId"
                                                                            error={
                                                                                errors.qsId
                                                                            }
                                                                        />
                                                                    )}

                                                                    {objects && (
                                                                        <SelectFieldGroup
                                                                            label={
                                                                                'Qlik Sense Object ID'
                                                                            }
                                                                            onChange={
                                                                                this
                                                                                    .handleSelect
                                                                            }
                                                                            value={
                                                                                this
                                                                                    .state
                                                                                    .object
                                                                                    .qsId ||
                                                                                ''
                                                                            }
                                                                            name={
                                                                                'qsId'
                                                                            }
                                                                            errors={
                                                                                errors.qsId
                                                                            }
                                                                            options={
                                                                                objects
                                                                            }
                                                                        />
                                                                    )}
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={3}
                                                                >
                                                                    <TextFieldGroup
                                                                        label="Title"
                                                                        type="text"
                                                                        onChange={
                                                                            this
                                                                                .onChange
                                                                        }
                                                                        value={
                                                                            this
                                                                                .state
                                                                                .object
                                                                                .title ||
                                                                            ''
                                                                        }
                                                                        name="title"
                                                                        error={
                                                                            errors.title
                                                                        }
                                                                    />
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={3}
                                                                >
                                                                    <SelectFieldGroup
                                                                        label="Export Data"
                                                                        type="text"
                                                                        options={[
                                                                            {
                                                                                key: 'enabled',
                                                                                title: 'Enabled',
                                                                            },
                                                                            {
                                                                                key: 'disabled',
                                                                                title: 'Disabled',
                                                                            },
                                                                        ]}
                                                                        onChange={
                                                                            this
                                                                                .handleSelect
                                                                        }
                                                                        value={
                                                                            this
                                                                                .state
                                                                                .object
                                                                                .exportData ||
                                                                            ''
                                                                        }
                                                                        name="exportData"
                                                                        error={
                                                                            errors.exportData
                                                                        }
                                                                    />
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                >
                                                                    <TextAreaFieldGroup
                                                                        label="Chart Description"
                                                                        type="text"
                                                                        onChange={
                                                                            this
                                                                                .onChange
                                                                        }
                                                                        value={
                                                                            this
                                                                                .state
                                                                                .object
                                                                                .description ||
                                                                            ''
                                                                        }
                                                                        name="description"
                                                                        error={
                                                                            errors.description
                                                                        }
                                                                    />
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    style={{
                                                                        paddingTop: 20,
                                                                    }}
                                                                >
                                                                    <Divider />
                                                                    <Typography
                                                                        className={
                                                                            ' '
                                                                        }
                                                                        variant={
                                                                            'subtitle1'
                                                                        }
                                                                    >
                                                                        Appearance
                                                                    </Typography>
                                                                    <Typography
                                                                        className={
                                                                            ' '
                                                                        }
                                                                        vatiant={
                                                                            'caption'
                                                                        }
                                                                    >
                                                                        Each
                                                                        grid row
                                                                        is split
                                                                        into 12
                                                                        columns
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={3}
                                                                >
                                                                    <TextFieldGroup
                                                                        label="Mobile Columns"
                                                                        type="text"
                                                                        onChange={
                                                                            this
                                                                                .onChange
                                                                        }
                                                                        value={
                                                                            this
                                                                                .state
                                                                                .object
                                                                                .xs
                                                                        }
                                                                        name="xs"
                                                                        error={
                                                                            errors.xs
                                                                        }
                                                                    />
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={3}
                                                                >
                                                                    <TextFieldGroup
                                                                        label="Tablet Columns"
                                                                        type="text"
                                                                        onChange={
                                                                            this
                                                                                .onChange
                                                                        }
                                                                        value={
                                                                            this
                                                                                .state
                                                                                .object
                                                                                .sm
                                                                        }
                                                                        name="sm"
                                                                        error={
                                                                            errors.sm
                                                                        }
                                                                    />
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={3}
                                                                >
                                                                    <TextFieldGroup
                                                                        label="Desktop Columns"
                                                                        type="text"
                                                                        onChange={
                                                                            this
                                                                                .onChange
                                                                        }
                                                                        value={
                                                                            this
                                                                                .state
                                                                                .object
                                                                                .md
                                                                        }
                                                                        name="md"
                                                                        error={
                                                                            errors.md
                                                                        }
                                                                    />
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={3}
                                                                >
                                                                    <TextFieldGroup
                                                                        label="Elevation"
                                                                        type="text"
                                                                        onChange={
                                                                            this
                                                                                .onChange
                                                                        }
                                                                        value={
                                                                            this
                                                                                .state
                                                                                .object
                                                                                .elevation
                                                                        }
                                                                        name="elevation"
                                                                        error={
                                                                            errors.elevation
                                                                        }
                                                                    />
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                >
                                                                    <Button
                                                                        color={
                                                                            'primary'
                                                                        }
                                                                        type="submit"
                                                                        className={`c-btn ${classes.buttonPrimary}`}
                                                                    >
                                                                        Create
                                                                        Object
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Section>
                    </Box>
                </div>
            </AdminLayout>
        );
    }
}

CreateObject.propTypes = {
    auth: PropTypes.object.isRequired,
    pages: PropTypes.object.isRequired,
    getObjects: PropTypes.func.isRequired,
    getPage: PropTypes.func.isRequired,
    createObject: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    getQlikSheets: PropTypes.func.isRequired,
    getQlikObjects: PropTypes.func.isRequired,
    qlik: PropTypes.object.isRequired,
    classes: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    qsServer: PropTypes.object,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    pages: state.pages,
    objects: state.objects,
    errors: state.errors,
    qsServer: state.qsServer,
    qlik: state.qlik,
});

export default connect(mapStateToProps, {
    createObject,
    getPages,
    getObjects,
    getPage,
    getQlikSheets,
    getQlikObjects,
})(withRouter(withStyles(styles)(CreateObject)));
